import React, { useState, useMemo, useEffect, useRef } from 'react';
import {Link} from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { mapData } from '../datamapper';
import { useSearch } from './searchcontext';
import '../nexus.css';
import SortButton from './_sortbuttons';
import CartOverlay from './overlay_cart';
import WishOverlay from './overlay_wishlist';




const NexusSelect = () => {
    const {searchParams, setSearchParams, offset, setOffset} = useSearch(); 

    const themenParam = searchParams["themen1"];

    const [lieferbar, setLieferbar] = useState('');
    const [nexusSelect, setNexusSelect] = useState([]);
    const navigate = useNavigate();

   

    const [topThemen, setTopThemen] = useState([]);
    const [selectedThemenCodes, setSelectedThemenCodes] = useState([])


    const [searchTerm, setSearchTerm] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const resultsEndRef = useRef(null);
    const [loadingMore, setLoadingMore] = useState(false);
    const [sort, setSort] = useState({ field: 'rang', order: 'desc' });
    const [isVisible, setIsVisible] = useState(false);
    const [isErweitert, setIsErweitert] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [activeIsbn, setActiveIsbn] = useState(null);
    const [showCartOverlay, setShowCartOverlay] = useState(false);
    const [showWishOverlay, setShowWishOverlay] = useState(null);
    const [cartOverlayItem, setCartOverlayItem] = useState(null);

    const [openRabattId, setOpenRabattId] = useState(null);

    const location = useLocation();


    /*verhindern mehreres requests gleichzeitig*/
    const abortRef = useRef(null);

    const fetchNexusSelect = (queryParams, count = 20, offset = 0, restoreScroll = false) => {
        const apiUrl = `/search?${queryParams}&count=${count}&offset=${offset}`;

        if (abortRef.current) abortRef.current.abort();
        const controller = new AbortController();
        abortRef.current = controller;

        fetch(apiUrl, { signal: controller.signal })
            .then(response => response.json())
            .then(data => {
                const nexusSelectData = mapData(data);
                const allResults = offset === 0 ? nexusSelectData : [...nexusSelect, ...nexusSelectData];
                setNexusSelect(allResults);
                setTotalCount(data.totalCount);

             
                sessionStorage.setItem('nexusSelect', JSON.stringify(allResults));
                sessionStorage.setItem('offset', offset);
                sessionStorage.setItem('totalCount', data.totalCount);

                
                const top = getTopThemen(nexusSelectData, 100, 10);
                setTopThemen(top);

                if (restoreScroll && resultsEndRef.current) {
                    setTimeout(() => {
                        resultsEndRef.current.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }



            })
            .catch(error => {
                if (error.name === "AbortError") return;
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        if (location.pathname === '/suche') {
          const stored = sessionStorage.getItem('selectedThemenCodes');
          if (stored) {
            try {
              const parsed = JSON.parse(stored);
              if (parsed.length > 0) {
                applyThemenCodes(parsed);
              }
            } catch (e) {
              console.warn('Could not parse selectedThemenCodes');
            }
          }
        }
      }, [location.pathname]);

    useEffect(() => {
        if (!isInitialLoad && loadingMore && resultsEndRef.current) {
            setTimeout(() => {
                resultsEndRef.current.scrollIntoView({ behavior: 'smooth' });
                setLoadingMore(false);
            }, 100); // Verzögerung 
        }
    }, [nexusSelect, loadingMore]);



    useEffect(() => {
        const storedParams = sessionStorage.getItem('searchParams');
        if (storedParams) {
            try {
                const parsedParams = JSON.parse(storedParams);
                setSearchParams(parsedParams);
            } catch (err) {
                console.error('Error parsing stored searchParams:', err);
            }
        }
    }, []);

    useEffect(() => {
        if (location.search.includes('themen=')) {
         
          sessionStorage.removeItem('searchParams');
          setSearchParams({ themen: new URLSearchParams(location.search).get('themen') });
        }
      }, []);

    // "search" beim Zurückkehren zur Seite
    useEffect(() => {
        const queryParams = Object.keys(searchParams)
          .filter(key => searchParams[key])
          .map(key => `${key}=${encodeURIComponent(searchParams[key])}`)
          .join('&');
      
        const storedResults = sessionStorage.getItem('nexusSelect');
        const storedOffset = sessionStorage.getItem('offset');
        const storedTotalCount = sessionStorage.getItem('totalCount');
        const preloadedSearch = sessionStorage.getItem('preloadedSearch');
      
        const shouldRestore =
          isInitialLoad &&
          storedResults &&
          (!preloadedSearch || preloadedSearch === 'true');
      
        if (shouldRestore) {
          const parsedResults = JSON.parse(storedResults);
          setNexusSelect(parsedResults);
          setOffset(storedOffset ? parseInt(storedOffset, 10) : 0);
          setTotalCount(storedTotalCount ? parseInt(storedTotalCount, 10) : 0);
      
          const top = getTopThemen(parsedResults, 100, 10);
          setTopThemen(top);
      
          setTimeout(() => {
            if (resultsEndRef.current) {
              resultsEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }, 200);
        } else {
          
          fetchNexusSelect(queryParams, 20, 0, true);
        }
      
        
        sessionStorage.removeItem('preloadedSearch');
        setIsInitialLoad(false);
      }, [searchParams]);

    useEffect(() => {
        if (location.search.includes('themen=')) {
         
          sessionStorage.removeItem('searchParams');
          sessionStorage.removeItem('stichwort');
        }
      }, []);

    //Ermittlung der Top Themen innerhalb der ersten 50 Suchtreffer

    function getTopThemen(results = [], limit = 100, topCount = 10) {
        if (!Array.isArray(results)) {
          console.error("Expected an array for search results, but got:", results);
          return [];
        }
      
        const themenCount = {};
        const labelMap = {};
      
        const limitedResults = results.slice(0, limit);
      
        limitedResults.forEach(item => {
          const { themen = [], themen_bezeichnungen = [] } = item;
      
          // gleiche length
          if (Array.isArray(themen) && Array.isArray(themen_bezeichnungen) && themen.length === themen_bezeichnungen.length) {
            themen.forEach((code, index) => {
              labelMap[code] = themen_bezeichnungen[index];
              themenCount[code] = (themenCount[code] || 0) + 1;
            });
          }
      
           // ungleiche length
          else if (Array.isArray(themen)) {
            themen.forEach(code => {
              themenCount[code] = (themenCount[code] || 0) + 1;
            });
          }
        });
      
        return Object.entries(themenCount)
          .sort((a, b) => b[1] - a[1])
          .slice(0, topCount)
          .map(([code, count]) => ({
            code,
            label: labelMap[code] || code,
            count,
          }));
      }

      function toggleThema(code) {
        let updated;
      
        if (selectedThemenCodes.includes(code)) {
          updated = selectedThemenCodes.filter(c => c !== code);
        } else {
          updated = [...selectedThemenCodes, code];
        }
      
        setSelectedThemenCodes(updated);
        sessionStorage.setItem('selectedThemenCodes', JSON.stringify(updated)); 
      
        const queryParams = buildQueryWithThemen(updated);
        fetchNexusSelect(queryParams, 20, 0, false);
      }

      function applyThemenCodes(codes) {
        console.log('Applying topic codes:', codes);
        setSelectedThemenCodes(codes);
        sessionStorage.setItem('selectedThemenCodes', JSON.stringify(codes)); 
      
        const queryParams = buildQueryWithThemen(codes);
        fetchNexusSelect(queryParams, 20, 0, false);
      }

      function buildQueryWithThemen(codes) {
        const otherParams = Object.keys(searchParams)
          .filter(key => key !== 'themen' && key !== 'themen1' && searchParams[key])
          .map(key => `${key}=${encodeURIComponent(searchParams[key])}`)
          .join('&');
      
        let themenParams = '';
        if (codes.length > 0) {
          themenParams = `themen=${codes.join(',')}`;
        }
      
        return [otherParams, themenParams].filter(Boolean).join('&');
    }      

      useEffect(() => {
        const params = new URLSearchParams(location.search);
        const codes = [];
      
        const first = params.get('themen');
        if (first) codes.push(first);
      
        const rest = params.getAll('themen1');
        if (rest.length > 0) codes.push(...rest);
      
        if (codes.length > 0) {
          console.log('Detected themen params on entry:', codes);
          applyThemenCodes(codes.map(String));
        }
      }, [location.search]);

  


    const loadMore = () => {
        const newOffset = offset + 20;
        setOffset(newOffset);
        setLoadingMore(true);

        const queryParams = Object.keys(searchParams)
            .filter(key => searchParams[key])
            .map(key => `${key}=${encodeURIComponent(searchParams[key])}`)
            .join('&');

        fetchNexusSelect(queryParams, 20, newOffset, true);
    };

  /*  useEffect(() => {
        if (!isInitialLoad) {
            handleSearch();
        }
    }, [searchParams]);*/

    useEffect(() => {
        if (isInitialLoad) return;
      
        const t = setTimeout(() => {
          handleSearch();
        }, 350); 
      
        return () => clearTimeout(t);
      }, [searchParams, isInitialLoad]);

    const handleSearch = () => {

        const queryParams = Object.keys(searchParams)
            .filter(key => searchParams[key])
            .map(key => `${key}=${encodeURIComponent(searchParams[key])}`)
            .join('&');

        setOffset(0);
        fetchNexusSelect(queryParams, 20, 0);
    };

    const handleResetSearch = () => {
        
        const clearedParams = {
            stichwort: '',
            themen_bezeichnungen: '',
            verlag: '',
            ean: '',
            autor: '',
            
          };
        
        setSearchParams(clearedParams);
        
        
        
        sessionStorage.removeItem('searchParams');
        setSort({ field: 'rang', order: 'desc' });
        setOffset(0);
        setNexusSelect([]);
        setTotalCount(0);
        setSelectedThemenCodes([]);          
        fetchNexusSelect('', 20, 0);
    };

    const handleLieferbarChange = (e) => {
        setSearchParams({ ...searchParams, lieferbar: e.target.checked ? 1 : 0 });
        setOffset(0);
    };

    const handleSort = (field) => {
        const newOrder = sort.order === 'asc' ? 'desc' : 'asc';
        setSort({ field, order: newOrder });

        setSearchParams({ ...searchParams, sort: field, sort_order: newOrder });
    };
    
    
    const toggleDetailSearchDiv = () => {
        setIsVisible(!isVisible);
        setIsErweitert(!isErweitert);
    }

   
    const toggleRabatt = (isbn) => {

        setOpenRabattId(prev =>
            prev === isbn ? null : isbn
        );
    
    }
    



    const preisAnzeige = (preis) => {
        return preis.toFixed(2).replace('.',',');
    }

    const selectedItem = nexusSelect.find((item) => item.isbn === showCartOverlay);
    




    return (
        <div className="contentContainer">
            
            <div className="sucheBibGrid">
                    <div className="sucheBibStichwort umBorderLeft"> 
                            <input className='suchEingabe' type='text' name='sucheTitel' id='sucheTitel' placeholder='Suchbegriff'
                                        value={searchParams.stichwort}
                                        onChange={(e) => setSearchParams({ ...searchParams, stichwort: e.target.value })}   
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter') {
                                                handleSearch();
                                                }
                                            }}
                                       
                            />
                            <br />
                            <br />

                            <input className='suchEingabe' type='text' name='sucheThema' id='sucheThema'  placeholder='Thema'
                                value={searchParams.themen_bezeichnungen}
                                onChange={(e) => setSearchParams({ ...searchParams, themen_bezeichnungen: e.target.value })}  
                                onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    handleSearch();
                                    }
                                }
                             }
                
                             />                   

                            
                            <br />


                            <div className={`sucheBibErweitert ${isVisible  ? 'visible' : 'hidden'}`}> 
                                                        <input className='suchEingabe inputStyle' type='text' name='sucheAutor' id='sucheAutor'  placeholder='Autor'
                                                            value={searchParams.autor}
                                                            onChange={(e) => setSearchParams({ ...searchParams, autor: e.target.value })}   
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    handleSearch();
                                                                    }
                                                                }}
                                                        />
                                                        
                                                        <input className='suchEingabe inputStyle' type='text' name='sucheISBN' id='sucheISBN'  placeholder='ISBN/EAN'
                                                            value={searchParams.ean}
                                                            onChange={(e) => setSearchParams({ ...searchParams, ean: e.target.value })}  
                                                            onKeyDown={(event) => {
                                                            if (event.key === 'Enter') {
                                                                handleSearch();
                                                                }
                                                            }
                                                        }
                                                        />


                                                        <input className='suchEingabe inputStyle' type='text' name='sucheVerlag' id='sucheVerlag' placeholder='Verlag'
                                                            value={searchParams.verlag}
                                                            onChange={(e) => setSearchParams({ ...searchParams, verlag: e.target.value })}
                                                            onKeyDown={(event) => {
                                                            if (event.key === 'Enter') {
                                                                handleSearch();
                                                                }
                                                            }
                                                        }
                                                        />
                                            
                            </div> 

                            <div className="flexElementLieferbarErweitern">                           
                                <div className="lieferbarCheckbox">           
                                    <label for='sucheNurLieferbar'>nur sofort lieferbare Artikel anzeigen
                                        <input 
                                            type='checkbox' 
                                            name='sucheNurLieferbar' 
                                            id='sucheNurLieferbar' 
                                            checked={searchParams.lieferbar === 1}
                                            onChange={handleLieferbarChange}
                                        
                                            
                                            />
                                        <span class="customCheckbox"></span>
                                    </label>
                                </div>               
                                <div className='erweiternButton'>
                                    <Link className="iconNexusErweitert" onClick={toggleDetailSearchDiv}>
                                        {isErweitert ? (                
                                                <>                
                                                    <span className="nexus-icon-reduziert"></span>
                                                    <span className="nexus-text">reduzieren</span>
                                                </> 
                                                ) : (
                                                    <>                
                                                    <span className="nexus-icon-erweitert"></span>
                                                    <span className="nexus-text">erweitern</span>
                                                </>     

                                                )
                                        }
                                        </Link>
                                </div>  
                            </div>     
                     </div>



                   

                    <div className="sucheBibGridDropdowns umBorderLeft">
                            <div className="sucheBibProduktGDropdown"> 
                                    <div className="dropDownLabel">Produktgruppe</div>   
                                    <div className="dropDownMenu">
                                        <select name='produktgruppeDropDown' id='produktgruppeDropDown' className="dropdown"
                                            value={searchParams.produktgruppe}
                                            onChange={(e) => setSearchParams({ ...searchParams, produktgruppe: e.target.value })}
                                        >
                                            <option value=''>Alle anzeigen</option>
                                            <option value='AL'>Buch</option>
                                            <option value='TB'>Taschenbuch</option>
                                            <option value='SB'>Schulbuch</option>
                                            <option value='HB'>Hörbuch</option>
                                            <option value='KA'>Kalender</option>
                                            <option value='NB'>Nonbook</option>
                                            <option value='SP'>Spiele</option>
                                            <option value='MU'>Musik CD</option>
                                        </select>
                                    </div>    
                            </div>
                            
                
                            <div className="sucheBibSpracheDropdown"> 
                                        <div className="dropDownLabel">Sprache</div>    
                                        <div className="dropDownMenu">
                                            <select name='spracheDropDown' id='spracheDropDown' className="dropdown"
                                                value={searchParams.sprache}
                                                onChange={(e) => setSearchParams({ ...searchParams, sprache: e.target.value })}
                                            >
                                                    <option value=''>Alle anzeigen</option>
                                                    <option value='GER'>Deutsch</option>
                                                    <option value='ENG'>Englisch</option>
                                                    <option value='FRE'>Französisch</option>
                                                    <option value='SPA'>Spanisch</option>
                                            </select>
                                        </div>    
                            </div>
               
                    </div>                          

                   
                                                        
             </div> 

                                         
             <div className="sucheBibSuchButton"> 
                                    <Link className="iconNexusSearch umbutton" onClick={handleSearch}>
                                       <span className="nexus-icon-search"></span>
                                       <span className="nexus-text">finden</span>
                                    </Link>

                               
                                                        
                                    <Link className="iconNexusReset" onClick={handleResetSearch}>
                                       <span className="nexus-icon-reset"></span>
                                       <span className="nexus-text">zurücksetzen</span>
                                    </Link>                               
                               
                    </div>                       

                     
                    <br></br>                             
                

                    <div className='bibHeadMenu'>
                        
                        <ul>
                        
                            <li>{totalCount} Artikel gefunden, sortiert nach:&nbsp; &nbsp; 
                                <SortButton field="rang" currentSort={sort} onClick={handleSort} text="Relevanz" />
                                <SortButton field="preis" currentSort={sort} onClick={handleSort} text="Preis" />
                                <SortButton field="datum_erscheinungstermin" currentSort={sort} onClick={handleSort}  text ="Datum"/>
                            </li>
                 
                        </ul>
                        <br />
                    </div>
                                                                      
                    <hr className='hrUmb'/>

             

                    

                    <div className='relevateThemen'>
                        <div className='umbStyledNotH'>Relevante Top-Themen:</div>
                        <br/>
                        <ul className="topThemenListe">
                            {topThemen.map((item, index) => {
                                const isActive = selectedThemenCodes?.includes(String(item.code));

                                return (
                                <li
                                    key={index}
                                    className={`einzelThema ${isActive ? 'activeThema' : ''}`}
                                >
                                    <button
                                    className="themaButton"
                                    onClick={() => toggleThema(item.code)}
                                    >
                                    {item.label}
                                    {isActive && (
                                        <span className="closeIcon">×</span>
                                    )}
                                    </button>
                                    {/* Optional:
                                    <span className="count">({item.count})</span>
                                    */}
                                </li>
                                );
                            })}
                            </ul>
                    </div>

                    <hr className='hrUmb'/>

                    <div className='bibResults'>

                        <div className="bibResultsGrid"> 
                       

                                {nexusSelect.map((item) => (
                                            <>
                                        
                                                    
                                                
                                                    <div className="bibResultsBox"  key={item.ean}  styles={{width: '15rem'}}>  
                                                            <div className="bibImgContainer umBorderRight">
                                                                <Link to={`/productdetails/${item.ean}`}>
                                                                    
                                                                
                                                                
                                                                    {Array.isArray(item.cover) && item.cover.length > 0 ? (
                                                                        
                                                                        <img styles={{height: '200px'}} src={item.cover[0]} alt="" />
                                                                    ) : (
                                                                        
                                                                        <img styles={{height: '200px'}} src="/assets/img/icons/noImage.png" alt="" />
                                                                    )}        


                                                                </Link>    
                                                            </div>     
                                                            <div className="card-body">
                                                                <div className='bibResultBoxTAP umBorderLeft'>
                                                                    <b>{item.titel}</b><br/>
                                                                    
                                                                
                                                                
                                                                </div>  
                                                                
                                                    
                                                    
                                                                <div className="bibResultBoxVerlag umBorderLeft">
                                                                    {item.autor}
                                                                    <br/>
                                                                    {item.verlag}
                                                                    <br/>
                                                                </div> 
                                                                
                                                                <div className='bibResultBoxPreis umBorderLeft'>    
                                                                 
                                                             
                                                                 <div style={{ display: "flex", gap: "8px"}}>
                                                                    <button className="showRabattButton" onClick={() => toggleRabatt(item.isbn)} >
                                                                        <b>{preisAnzeige(item.preis)} €</b>
                                                                    </button>  

                                                                        {openRabattId === item.isbn && (
                                                                            <div className="rabatt">
                                                                                Rabatt:  {Number((Number(item.rabatt) * (2 / 3)).toFixed(2))} %
                                                                            </div>
                                                                        )}  
                                                                  </div>         
                                                                <br/>
                                                                <div className='nexusMeldetext'>
                                                                    <div className={item.meldetext}>{item.meldetext}</div>
                                                                </div>  
                                                                </div>
                                                                

                                                                <div className='bibResultBoxButtons umBorderLeft umBorderRight'>
                                                                    
                                                                    <Link to={`/productdetails/${item.ean}`}>
                                                                        <button className="umbButtonIconInfo">
                                                                            <span className="iconInfoHover">
                                                                            </span>
                                                                        </button>    
                                                                    </Link>
                                                                        
                                                                    <button className="umbButtonIconList"
                                                                     onClick={() => setShowWishOverlay(item)}> 
                                                                        <span className="iconListHover"></span>

                                                                        


                                                                    </button> 

                                                                    {showWishOverlay && (
                                                                            <WishOverlay
                                                                                isbn={showWishOverlay.isbn}
                                                                                titel={showWishOverlay.titel}
                                                                                autor={showWishOverlay.autor}
                                                                                onClose={() => setShowWishOverlay(null)}
                                                                            />
                                                                        )}


                                                                    <button
                                                                        className="umbButtonIconCart" 
                                                                        onClick={() => {setShowCartOverlay(item.isbn)}}
                                                                    > 
                                                                        <span className="iconCartHover"></span>
                                                                    </button> 

                                                                    {selectedItem && (
                                                                        <CartOverlay
                                                                            isbn={selectedItem.isbn}
                                                                            titel={selectedItem.titel}
                                                                            preis={selectedItem.preis}
                                                                            autor={selectedItem.autor}
                                                                            onClose={() => setShowCartOverlay(null)}
                                                                        />
                                                                    )}
                                                                        
                                                                </div>
                                                            </div>
                                                            
                                                    
                                                                    
                                                    </div>

                                            </>  
                                                                                            

                                        
                                        
            
                                    ))}
                        </div>  

                            
                            <br/>        
                            <br/> 
                           {loadingMore && <div></div>}
                            {/*<div ref={resultsEndRef}></div>*/}
                            <div className="loadMoreButton">
                                
                                {nexusSelect.length < totalCount && <button className='' onClick={loadMore}>Weitere Suchergebnisse laden</button>}
                            </div>        

                    </div>
                                         
        </div>
    );
};

export default NexusSelect;


